<script setup lang="ts">
    import { type Table } from '@tanstack/vue-table';
    import { Plus, Minus } from 'lucide-vue-next';

    import { Button } from '@/components/ui/button';

    interface DataTablePaginationProps {
        table: Table<any>;
    }
    defineProps<DataTablePaginationProps>();
</script>

<template>
    <Button
        v-if="table.getCanSomeRowsExpand()"
        variant="ghost"
        width="narrow"
        class="self-start"
        :class="table.getIsAllRowsExpanded() ? 'hover:text-destructive' : 'hover:text-accent'"
        size="xs"
        @click="table.toggleAllRowsExpanded(!table.getIsAllRowsExpanded())"
    >
        {{
            table.getIsAllRowsExpanded()
                ? $t('datatables.collapse_all')
                : $t('datatables.expand_all')
        }}
        <Minus
            v-if="table.getIsAllRowsExpanded()"
            class="text-destructive"
        />
        <Plus
            v-else
            class="text-accent"
        />
    </Button>
</template>
